import { render } from "./DraggableNavList.vue?vue&type=template&id=7b662e76&scoped=true"
import script from "./DraggableNavList.vue?vue&type=script&lang=js"
export * from "./DraggableNavList.vue?vue&type=script&lang=js"

import "./DraggableNavList.vue?vue&type=style&index=0&id=7b662e76&scoped=true&lang=css"

import exportComponent from "/opt/compla/docker/sites/my-atw-global/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b662e76"]])

export default __exports__